/* eslint-disable @typescript-eslint/naming-convention */
import { Threshold } from '../basketsize-template/types/propTypes';

// TODO: Make the cmsData prop non optional afterwards
export interface SubscriptionPlanPropType {
  planId: string;
  sopPlanDetailsCMSData?: CMSPlanDetails;
}

export interface CMSPlanDetails {
  _version: number;
  locale: string;
  uid: string;
  ACL: Record<string, unknown>;
  _in_progress: boolean;
  created_at: string;
  created_by: string;
  plan_details: Record<string, unknown>;
  primary_plan_code: string;
  secondary_plan_codes: string;
  rewards_and_benefits: Record<string, unknown>;
  start_subscription: Record<string, unknown>;
  template: string;
  title: string;
  top_banner: Record<string, unknown>;
  url: string;
  tags: string[];
  updated_at: string;
  updated_by: string;
  publish_details: {
    environment: string;
    locale: string;
    time: string;
    user: string;
  };
  plan_threshold_details?: {
    default_message: string;
    thresholds: Threshold[];
  };
}

export interface ContainerStepProps {
  id: number;
  isAccordianOpened: boolean;
  isVisited: boolean;
  isCompleted: boolean;
}

export enum TemplateEnum {
  NORMAL = 'Normal',
  FIXED = 'Fixed',
  BASKET_SIZE = 'BasketSize',
  DYNAMIC = 'Dynamic',
  MULTIPLE_BUNDLE = 'MultipleBundle',
}
